import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BaseGuard } from '@core/ngrx';
import { getBackLink } from '@core/jss-routing';
import { createSelector, Store } from '@ngrx/store';
import type { GuardInput } from '@sitecore-jss/sitecore-jss-angular';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { isAddressLoading } from '../address/address.selectors';
import { isConsumptionLoading } from '../consumption';
import { getOfferAction, setSelectedFlowIdAction } from '../flow/flow.actions';
import { setSelectedOfferAction } from '../offer/retention-offer.actions';

const isLoading = createSelector(
  isAddressLoading,
  isConsumptionLoading,
  (loadingAddress, loadingConsumption) => loadingAddress || loadingConsumption
);

@Injectable({ providedIn: 'root' })
export class RetentionOrderGuard extends BaseGuard {
  protected isStateLoading(input: GuardInput) {
    return this.store$.select(getBackLink).pipe(
      switchMap((url) => {
        if (
          ((input.activatedRoute.queryParams['flowId'] == null ||
            input.activatedRoute.queryParams['campaignId']) == null ||
            input.activatedRoute.queryParams['duration'] == null) &&
          url
        ) {
          return of(this.router.parseUrl(url.href));
        } else {
          return this.store$.select(isLoading);
        }
      })
    );
  }
  protected getDispatchActions() {
    return [getOfferAction()];
  }

  override canActivate(input: GuardInput) {
    this.store$.dispatch(
      setSelectedOfferAction({
        payload: {
          rendering: input.rendering,
          campaignId: input.activatedRoute.queryParams['campaignId'],
          duration: input.activatedRoute.queryParams['duration'],
        },
      })
    );
    this.store$.dispatch(
      setSelectedFlowIdAction({
        payload: input.activatedRoute.queryParams['flowId'],
      })
    );
    return super.canActivate(input);
  }

  constructor(
    protected override readonly injector: Injector,
    protected readonly store$: Store<any>,
    protected readonly router: Router
  ) {
    super(injector);
  }
}
